module.exports = __webpack_public_path__ + "static/media/slzhitui-fuwu-1.973ea829.png";